import React, { Component } from 'react';

import { Card, CardBody, Button, FormGroup, Label, Col, Input } from 'reactstrap';
import { AvForm, AvField } from 'availity-reactstrap-validation';

export default class RegisterUser extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    render() {
        return (
            <Card>
                <CardBody>
                <AvForm
                    className="form-horizontal"
                    onValidSubmit={() => {
                        this.toggleTab(this.state.activeTab + 1);
                    }}>
                    <FormGroup row>
                        <Label htmlFor="example-text-input" className="col-md-2 col-form-label">
                            Firstname
                        </Label>
                        <Col md={5}>
                            <AvField
                                name="firstname"
                                className="form-control"
                                type="text"
                                placeholder="Isim"
                                id="firstname"
                                errorMessage="Enter Persons First Name"
                                validate={{ required: { value: true } }}
                                onChange={this.stateHandling}
                                value={this.state.firstname}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label htmlFor="example-text-input" className="col-md-2 col-form-label">
                            Middle Name
                        </Label>
                        <Col md={5}>
                            <Input
                                className="form-control"
                                type="text"
                                placeholder="Leqimi / Texellusi"
                                id="middleName"
                                onChange={this.stateHandling}
                                value={this.state.middleName}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label htmlFor="example-text-input" className="col-md-2 col-form-label">
                            Lastname
                        </Label>
                        <Col md={5}>
                            <AvField
                                name="lastname"
                                className="form-control"
                                type="text"
                                placeholder="Familisi"
                                id="lastname"
                                errorMessage="Enter Persons Last Name"
                                validate={{ required: { value: true } }}
                                onChange={this.stateHandling}
                                value={this.state.lastname}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row>
                        <Label htmlFor="example-number-input" className="col-md-2 col-form-label">
                            Age
                        </Label>
                        <Col md={5}>
                            <Input
                                className="form-control"
                                type="number"
                                placeholder="yishi"
                                id="age"
                                onChange={this.stateHandling}
                                value={this.state.age}
                            />
                        </Col>
                    </FormGroup>
                    <FormGroup row onChange={this.radioBtnChange}>
                        <Label className="col-md-2 col-form-label">Gender</Label>
                        <Col md={2}>
                            <div className="custom-control custom-radio mb-3">
                                <Input type="radio" id="genderMale" value="Male" name="gender" className="custom-control-input" />
                                <Label className="custom-control-label" htmlFor="genderMale">
                                    Male
                                </Label>
                            </div>
                        </Col>
                        <div className="custom-control custom-radio mb-3">
                            <Input type="radio" id="genderFemale" value="Female" name="gender" className="custom-control-input" />
                            <Label className="custom-control-label" htmlFor="genderFemale">
                                Female
                            </Label>
                        </div>
                    </FormGroup>
                    <FormGroup row>
                        <Label htmlFor="example-text-input" className="col-md-2 col-form-label">
                            Place of Birth
                        </Label>
                        <Col md={5}>
                            <Input
                                className="form-control"
                                type="text"
                                placeholder="Tugulgan Yurti"
                                id="placeOfBirth"
                                onChange={this.stateHandling}
                                value={this.state.placeOfBirth}
                            />
                        </Col>
                    </FormGroup>
                </AvForm>
                </CardBody>
                <CardBody>
                    <Button color="primary" onClick={() => this.props.history.push('/register/user')}>Register User</Button>
                </CardBody>
            </Card>
        )
    }
}
